import React from 'react'
import { COLOR_INTENT } from 'Theme'

interface HeaderLogoProps {
  width?: string
  height?: string
  color?: string
  titleId: string
}

export const HeaderLogo: React.FC<React.PWC<HeaderLogoProps>> = ({
  width = '122px',
  height = '40px',
  color = COLOR_INTENT.LOGO_DEFAULT,
  titleId,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 122 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
  >
    <title id={titleId}>The Expert Logo</title>
    <path
      fill={color}
      d="m11.7 24.3 2.8-10.5h-2.1l.3-1 2.2-.3 1-3.6H18l-1 3.8h2.7v1h-3l-3 10 1.8.1 2-2.5.2.2c-1.2 2.4-2.6 3.7-3.5 3.7-.5 0-2.7-.6-2.6-1Zm13.7-.2c0-.4 1-3.2 1.8-5.3.6-1.5 1.4-3.3 1.4-3.9 0-.5-.7-1-1.3-1-.9 0-2.8 2.8-5.2 8l-1 3-2.3-.1 1.5-4.5L23.6 8l-.1-.6-2.1-.3v-.3l5-.7-.9 3.2c-1.3 4.5-2.6 9.2-3.4 11.2h.2a33 33 0 0 1 4.3-7c.5-.6 1.3-1 2-1 1 0 2.1.7 2.1 1.6 0 .9-.6 2.8-1.3 4.7l-1.8 5 1.2.1 2-2.5.2.2c-1.1 2.4-2.6 3.7-3.5 3.7-.6 0-2.1-.7-2.1-1Zm7.2-3c0-4 3.5-8.8 6.9-8.8 1.8 0 3 1 3 2.3 0 1.8-2.3 2.8-7.3 4.2l-.2 1.9c0 2 .8 3 2.3 3 1.2 0 2-.7 3.5-2.6l.3.2c-1.3 2-3 3.8-4.9 3.8-2.1 0-3.6-1.8-3.6-4Zm7.8-6.7A1.4 1.4 0 0 0 39 13c-.6 0-1 .3-1.5.7-.8.8-1.7 2.6-2.2 4.7 3.9-1.2 5-2.2 5-4Zm6.2 4.6c0-3.8 2.7-6.8 6.4-6.8 3 0 4.7 1.8 4.7 4l-.1.8h-8v1c0 3.2 1.8 5.3 4.2 5.3a4 4 0 0 0 3.7-2l.3.1c-1.2 2.4-3 3.8-5.4 3.8-3.3 0-5.8-2.7-5.8-6.1Zm8.2-2.6c0-1.9-.6-3.6-2.1-3.6s-2.7 1.6-3 3.7h5.1Zm3.7 8 .7-.1c1-.2 1.5-.7 3-2.6l1.8-2.4-2.9-4.1c-1-1.4-1.4-2-2.1-2h-.5v-.5H65l-.1.4-.6.1c-.9 0-.8.6 0 1.8l1.6 2.4 1.4-1.9c1.2-1.7 1.2-2.2 0-2.3h-.6l-.1-.5h5l-.1.4-.7.1c-1 .2-1.5.7-3 2.7l-1.5 1.9 3.1 4.5c1 1.3 1.5 1.9 2.1 2h.5v.5h-6.4v-.4l.6-.1c.9-.1.8-.6 0-1.8l-1.8-2.8-1.7 2.3c-1.2 1.7-1.2 2.2 0 2.3h.7v.5h-5l.1-.4Zm14.3 7h.6c.8-.1 1.1-.2 1.1-.5V16.2c0-1.7-.2-2-1.2-2.2l-.6-.1v-.4l4.6-1.2v2.5c1.2-1.3 2.6-2.4 4.3-2.4 2.9 0 5 2.5 5 6 0 4.3-3.2 6.8-6.5 6.8a7 7 0 0 1-2.8-.5v6.2c0 .3.1.4 1.3.4h1v.5h-6.9l.1-.4Zm10.8-12.2c0-2.8-1.4-5-3.6-5a3.7 3.7 0 0 0-2.7 1.3v6.6c.7 1.4 2 2.5 3.2 2.5 1.9 0 3-2.4 3-5.4Zm4.7-.2c0-3.8 2.7-6.8 6.4-6.8 2.9 0 4.6 1.8 4.6 4v.8h-8v1c0 3.2 1.7 5.3 4.2 5.3a4 4 0 0 0 3.6-2l.3.1c-1.1 2.4-2.9 3.8-5.4 3.8-3.3 0-5.7-2.7-5.7-6.1Zm8.2-2.6c0-1.9-.6-3.6-2.2-3.6-1.4 0-2.7 1.6-3 3.7h5.2Zm4.3 7.9h.5c.8 0 1.1-.1 1.1-.5v-7.5c0-1.8-.2-2-1.2-2.3l-.6-.1v-.4l4.6-1.2v4.2c1-2.7 2.1-4.2 3.8-4.2 1 0 2 .7 2 1.7a1.6 1.6 0 0 1-.5 1.2 1.6 1.6 0 0 1-1.2.5 1.8 1.8 0 0 1-1.8-1.6c-.9.3-1.6 1.4-2.3 3.6V24c0 .3.2.4 1.3.4h.8l.1.5h-6.7v-.5Zm13.3-2.6.2-7.6H112l.3-.8L114 12l2.6-2h.4v2.7h4.3L121 14h-4l-.2 7.3c0 1.5.7 2.2 2.1 2.2a4 4 0 0 0 2.4-.8v.3a5.5 5.5 0 0 1-4 2.1c-2 0-3.2-1-3.2-3.4ZM.1-.3H1v39.5H.1V-.3Z"
    />
  </svg>
)
